import { render } from "./CmpSecciones.vue?vue&type=template&id=2a8c0b7f&scoped=true"
import script from "./CmpSecciones.vue?vue&type=script&lang=js"
export * from "./CmpSecciones.vue?vue&type=script&lang=js"

import "./CmpSecciones.vue?vue&type=style&index=0&id=2a8c0b7f&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8c0b7f"]])

export default __exports__